module.exports = __webpack_public_path__ + "img/iconhairspa-white.87c24947.png";